// extracted by mini-css-extract-plugin
module.exports = {"summary__item":"K_cK","summary__item__name":"K_cL","summary__item__price":"K_cM","summary__col__wrap":"K_cN","summary__quantity":"K_cP"};